import { render, staticRenderFns } from "./TestimonialComponent.vue?vue&type=template&id=29f1cfd6&scoped=true&"
import script from "./TestimonialComponent.vue?vue&type=script&lang=js&"
export * from "./TestimonialComponent.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialComponent.vue?vue&type=style&index=0&id=29f1cfd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f1cfd6",
  null
  
)

export default component.exports